import { downloadBlob } from '@/utils'

import { CsvField, normalizeFieldsAndRows } from './download-csv.utils'

interface DownloadCsvOptions {
  blob?: Blob
  data?: unknown[]
  fields?: CsvField[]
  filename: string
}

export const downloadCsv = ({
  blob,
  data,
  fields,
  filename,
}: DownloadCsvOptions): Promise<void> => {
  if (blob) {
    downloadBlob(blob, filename)
    return Promise.resolve()
  }

  if (fields && data) {
    const normalized = normalizeFieldsAndRows(fields, data)

    return new Promise<void>((resolve) => {
      const worker = new Worker(new URL('./csv.worker.ts', import.meta.url), { type: 'module' })
      worker.postMessage(normalized)
      worker.onmessage = (event: MessageEvent<{ buffer: ArrayBuffer }>) => {
        downloadBlob(new Blob([event.data.buffer], { type: 'text/csv' }), filename)
        worker.terminate()
        resolve()
      }
    })
  }

  throw new Error('Either blob or (data + fields) must be provided')
}
